/**
 * TL;DR: Super-optimized Scroll & Resize RAF (Request Animation Frame) utility.
 * Features:
 * - Efficient scroll position and viewport size tracking
 * - Batches multiple listeners into single animation frame
 * - Tracks both current and previous states
 * - Memory-efficient with proper cleanup
 * - Used for scroll animations and responsive features
 */

var n,e,i,o,t,r,f,d,p,u=[];function w(n,a){return e=window.pageXOffset,o=window.pageYOffset,r=window.innerHeight,d=window.innerWidth,void 0===i&&(i=e),void 0===t&&(t=o),void 0===p&&(p=d),void 0===f&&(f=r),(a||o!==t||e!==i||r!==f||d!==p)&&(!function(n){for(var w=0;w<u.length;w++)u[w]({x:e,y:o,px:i,py:t,vh:r,pvh:f,vw:d,pvw:p},n);}(n),i=e,t=o,f=r,p=d),requestAnimationFrame(w)}function srraf(e){return u.indexOf(e)<0&&u.push(e),n=n||w(performance.now()),{update:function(){return w(performance.now(),!0),this},destroy:function(){u.splice(u.indexOf(e),1);}}}

export { srraf as s };
